<app-i18n-dictionary>
    <span [attr.transid]="fieldFirstNameTextId" i18n="@@field-first-name">First Name</span>
    <span [attr.transid]="fieldLastNameTextId" i18n="@@field-last-name">Last Name</span>

    <span [attr.transid]="fieldEmailTextId" i18n="@@email-placeholder">Email</span>
    <span [attr.transid]="fieldPasswordTextId" i18n="@@password-placeholder">Password</span>
    <span [attr.transid]="fieldConfirmPasswordTextId" i18n="@@confirm-password-placeholder">Confirm Password</span>
    <span [attr.transid]="fieldCompanyTextId" i18n="@@company-placeholder">Company</span>
    <span [attr.transid]="fieldStreetTextId" i18n="@@street-placeholder">Street</span>
    <span [attr.transid]="fieldCountryTextId" i18n="@@country-placeholder">Country</span>
    <span [attr.transid]="fieldCityTextId" i18n="@@city-placeholder">City</span>
    <span [attr.transid]="fieldZipTextId" i18n="@@zip-placeholder">Zip</span>
    <span [attr.transid]="fieldVatTextId" i18n="@@vat-placeholder">Vat</span>
    <span [attr.transid]="fieldPhoneTextId" i18n="@@phone-placeholder">Phone</span>
</app-i18n-dictionary>

<form fxLayout="column" [formGroup]="form" (ngSubmit)="register()">
    <div fxLayout="row" class="double-input">
        <mat-form-field>
            <input [autofocus]="true" type="text" matInput [placeholder]="i18nDictionary.get(fieldFirstNameTextId)" formControlName="firstName"
                   required [maxlength]="firstNameMaxLength" >
            <mat-error *ngIf="firstNameControl.hasError('required')"
                       i18n="@@request-quote-form_error-first-name-required">Please enter your first name
            </mat-error>
            <mat-error *ngIf="firstNameControl.hasError('maxlength')"
                       i18n="@@request-quote-form_error-first-name-maxlength">
                Your first name can't have more than {{firstNameMaxLength}} characters
            </mat-error>
        </mat-form-field>
        <mat-form-field>
            <input type="text" matInput [placeholder]="i18nDictionary.get(fieldLastNameTextId)" formControlName="lastName"
                   required [maxlength]="lastNameMaxLength">
            <mat-error *ngIf="lastNameControl.hasError('required')"
                       i18n="@@request-quote-form_error-last-name-required">Please enter your last name
            </mat-error>
            <mat-error *ngIf="lastNameControl.hasError('maxlength')"
                       i18n="@@request-quote-form_error-last-name-maxlength">
                Your last name can't have more than {{lastNameMaxLength}} characters
            </mat-error>
        </mat-form-field>
    </div>


    <mat-form-field>
        <input type="text" matInput
               [placeholder]="i18nDictionary.get(fieldCompanyTextId)"
               formControlName="company" required/>
        <mat-error *ngIf="companyControl.hasError('required')"
                   i18n="@@company-error-required">Please enter the name of your company
        </mat-error>
    </mat-form-field>
    <mat-form-field>
        <input type="text" matInput
               [placeholder]="i18nDictionary.get(fieldStreetTextId)"
               formControlName="street" required/>
        <mat-error *ngIf="streetControl.hasError('required')"
                   i18n="@@street-error-required">Please enter a street name
        </mat-error>
    </mat-form-field>
    <mat-form-field>
        <mat-select [placeholder]="i18nDictionary.get(fieldCountryTextId)" formControlName="countryId" required>
            <mat-option *ngIf="countriesIsPending" [value]="false">
                <mat-spinner [diameter]="20"></mat-spinner>
            </mat-option>
            <mat-option *ngFor="let country of _countries" [value]="country.iso2Code">
                {{country.name}}
            </mat-option>
        </mat-select>
    </mat-form-field>
    <div fxLayout="row" class="double-input">
        <mat-form-field>
            <input type="text" matInput
                   [placeholder]="i18nDictionary.get(fieldCityTextId)"
                   formControlName="city" required/>
            <mat-error *ngIf="cityControl.hasError('required')"
                       i18n="@@city-error-required">Please enter a city name
            </mat-error>
        </mat-form-field>
        <mat-form-field>
            <input type="text" matInput
                   [placeholder]="i18nDictionary.get(fieldZipTextId)"
                   formControlName="zipCode" required/>
            <mat-error *ngIf="zipControl.hasError('required')"
                       i18n="@@zip-error-required">Please enter a zip code
            </mat-error>
        </mat-form-field>
    </div>
    <mat-form-field>
        <input type="text" matInput
               [placeholder]="i18nDictionary.get(fieldVatTextId)"
               formControlName="vat"/>
    </mat-form-field>
    <mat-form-field>
        <input appIosAutoFillFix type="email" matInput
               [placeholder]="i18nDictionary.get(fieldEmailTextId)"
               formControlName="email" required/>
        <mat-error *ngIf="emailControl.hasError('required')"
                   i18n="@@email-error-required">Please enter an email
        </mat-error>
        <mat-error *ngIf="emailControl.hasError('email')"
                   i18n="@@email-error-email">Not a valid email
        </mat-error>
    </mat-form-field>
    <mat-form-field>
        <input appIosAutoFillFix type="text" matInput
               [placeholder]="i18nDictionary.get(fieldPhoneTextId)"
               formControlName="phone" required/>
        <mat-error *ngIf="phoneControl.hasError('required')"
                   i18n="@@email-error-required">Please enter a phone number
        </mat-error>
    </mat-form-field>
    <mat-form-field>
        <input type="password" matInput [placeholder]="i18nDictionary.get(fieldPasswordTextId)"
               formControlName="password" required/>
        <mat-error *ngIf="passwordControl.hasError('required')"
                   i18n="@@password-error-required">Please enter a password
        </mat-error>
        <mat-error *ngIf="passwordControl.hasError('pattern')"
                   i18n="@@password-error-pattern">Password should have a minimum of eight characters, at least one
            uppercase letter, one lowercase letter, one number and one special character
        </mat-error>
    </mat-form-field>
    <mat-form-field>
        <input appIosAutoFillFix type="password" matInput
               [placeholder]="i18nDictionary.get(fieldConfirmPasswordTextId)"
               formControlName="confirmPassword"/>
        <mat-error *ngIf="confirmPasswordControl.hasError('mismatch')"
                   i18n="@@password-mismatch">
            Passwords don't match
        </mat-error>
    </mat-form-field>

    <ng-hcaptcha formControlName="captcha" [languageCode]="currentLang"></ng-hcaptcha>
    <mat-error *ngIf="captchaControl.hasError('required') && captchaControl.touched"
               i18n="@@captcha-error-required">You must complete the CAPTCHA
    </mat-error>

    <div class="actions" fxLayout="row" fxLayoutAlign="center center" >
        <button fxFlex="1 1 auto" class="btn-primary main-btn" [disabled]="isPending" i18n="@@password-reset-form_submit-button">
            Submit
        </button>
        <mat-spinner [diameter]="25" *ngIf="isPending"></mat-spinner>
    </div>

    <div class="actions" fxLayout="row" fxLayoutAlign="center center">
        <button fxFlex="1 1 auto" class="btn-primary main-btn" [disabled]="isPending" i18n="@@password-reset-form_back-button"
                (click)="goBack()">Return to login
        </button>
    </div>

    <p *ngIf="error && !error.isGlobalMessage" class="registrationError">
        {{ error.errorMessage }} [{{ error.errorCodeFormatted }}]
    </p>

</form>

<p *ngIf="registrationSuccessful" class="registrationSuccessful"
   i18n="@@registration-form_registration_successful">
    Your account has been successfully requested. Please check your emails for further information.
</p>

<app-contact-box></app-contact-box>

